/**
 * User-facing labels for KnowledgePromptInstance.visibility — shared between
 * /prompts list (pill on each tile) + /prompts/:slug record page.
 */

import type { KnowledgePromptInstance } from '../../lib/api.ts';

export const VISIBILITY_LABEL: Record<KnowledgePromptInstance['visibility'], string> = {
  account_installed: 'Workspace',
  account_custom: 'Custom',
  user_private: 'Private',
  user_shared: 'Shared',
};
